module.exports = __webpack_public_path__ + "img/mx_seguromovil.17596cf5.png";